<app-page-heading
    [key]="(mode === DisplayMode.Creation ? 'user-dashboard.users.chep-service-rep.form.page-title.creation' : 'user-dashboard.users.chep-service-rep.form.page-title.update')" [subheadingIcon]="'fa fa-user-plus'"
    [i18nParams]="{userEmail: user.email}"
></app-page-heading>

<app-user-form #userForm
               [userTypeLabelKey]="'user-dashboard.groups.chep-service-rep'"
               [user]="user"
               [mode]="mode"

               [create]="onCreate"
               [update]="onUpdate"
               [remove]="onDelete"
               [block]="onToggleBlocking"
               [unblockIp]="onUnblockIp"

               (changePassword)="changePassword($event)"
               (afterCreate)="goToChepServiceRepList()"
               (afterDelete)="goToChepServiceRepList()"
>
</app-user-form>
